import { render, staticRenderFns } from "./billActualAmount.vue?vue&type=template&id=5b36b9d6&"
import script from "./billActualAmount.vue?vue&type=script&lang=js&"
export * from "./billActualAmount.vue?vue&type=script&lang=js&"
import style0 from "./billActualAmount.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b36b9d6')) {
      api.createRecord('5b36b9d6', component.options)
    } else {
      api.reload('5b36b9d6', component.options)
    }
    module.hot.accept("./billActualAmount.vue?vue&type=template&id=5b36b9d6&", function () {
      api.rerender('5b36b9d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Clearing/BillOverseasSCenter/components/view/billActualAmount.vue"
export default component.exports